import { schema } from 'normalizr';

export const bookSchema                   = new schema.Entity('book');
export const bookListSchema               = [bookSchema];

export const repSchema                    = new schema.Entity('rep');
export const repListSchema                = [repSchema];

export const appointmentSchema            = new schema.Entity('appointment', { office: bookSchema, rep: repSchema });
export const appointmentListSchema        = [appointmentSchema];

export const currentRepAppointmentsSchema = new schema.Entity('currentRepAppointments');
export const currentRepAppointmentsListSchema = [currentRepAppointmentsSchema];

export const doctorSchema                 = new schema.Entity('doctor');
export const doctorListSchema             = [doctorSchema];

export const doctorAvailabilitySchema     = new schema.Entity('doctorAvailability', { doctor: doctorSchema });
export const doctorAvailabilityListSchema = [doctorAvailabilitySchema];

export const paymentDetailsSchema =         new schema.Entity('paymentDetails');

export const transactionSchema            = new schema.Entity('transaction');
export const transactionListSchema        = [transactionSchema];

export const receivedTradeSchema = new schema.Entity('receivedTrades');
export const requestedTradeSchema = new schema.Entity('requestedTrades');

export const tradeOffers = new schema.Object({ receivedTrades: [receivedTradeSchema], requestedTrades: [requestedTradeSchema] });

export const myPostedOfferSchema = new schema.Entity('myPostedOffers', { requester: repSchema, offeredAppointment: appointmentSchema });
export const othersPostedOfferSchema = new schema.Entity('othersPostedOffers', { requester: repSchema, offeredAppointment: appointmentSchema });

export const postedOffers = new schema.Object({ myOffers: [myPostedOfferSchema], othersOffers: [othersPostedOfferSchema] });



// WEBPACK FOOTER //
// ./app/schemas/Normalizr.js